import type { HttpTypes } from "@medusajs/types"

type CartWithItems = Pick<HttpTypes.StoreCart, "items"> | null | undefined

export const cartHasVariant = (cart: CartWithItems, variantId?: string | null) => {
  if (!cart?.items?.length || !variantId) {
    return false
  }

  return cart.items.some((item) => item.variant_id === variantId)
}

export const getFriendlyCartErrorMessage = (error: unknown) => {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
      ? error
      : ""

  if (/required inventory|out of stock|insufficient inventory/i.test(message)) {
    return "This size is already in your bag or just sold out. Please check your bag before ordering."
  }

  return "We could not update your bag. Please try again."
}
